import { Fragment, type ReactNode } from "react";

/**
 * Endereços clicáveis no texto da North IA (o link da apresentação, por
 * exemplo). Aceita o endereço solto e o `[texto](endereço)` do markdown; só
 * http(s) vira link — qualquer outra coisa fica como texto.
 */
const LINK = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>()]*[^\s<>().,;:!?'"])/g;

export const comLinks = (texto: string, chave = "l"): ReactNode[] => {
  const partes: ReactNode[] = [];
  let ultimo = 0;
  for (const m of texto.matchAll(LINK)) {
    const inicio = m.index ?? 0;
    if (inicio > ultimo) partes.push(<Fragment key={`${chave}-t${inicio}`}>{texto.slice(ultimo, inicio)}</Fragment>);
    const href = m[2] ?? m[3];
    partes.push(
      <a
        key={`${chave}-a${inicio}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary underline underline-offset-2 break-all"
      >
        {m[1] ?? href}
      </a>,
    );
    ultimo = inicio + m[0].length;
  }
  if (ultimo < texto.length) partes.push(<Fragment key={`${chave}-t${ultimo}`}>{texto.slice(ultimo)}</Fragment>);
  return partes;
};
